import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__audit_request_accept',
    path: '/audits/audit-request/:requestId/accept',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/audits/accept-audit-request.vue' /* webpackChunkName: "pages-audits-accept-audit-request.vue" */
        )
      )
  },
  {
    name: '__audit_request',
    path: '/audits/requests/:requestId/',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/audits/audit-request.vue' /* webpackChunkName: "pages-audits-audit-request.vue" */
        )
      )
  },
  {
    name: `__audit_certificates_view`,
    path: '/audits/certificates/:certificateId',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/audits/certificate.vue' /* webpackChunkName: "pages-audits-audit-certificate" */
        )
      )
  }
]
